/*
 * @Author: xuesong
 * @Date: 2021-04-15 13:57:28
 * @LastEditors: xuesong
 * @LastEditTime: 2021-04-28 14:46:51
 * @Description: 
 */
import TIM from 'tim-js-sdk';
import COS from "cos-js-sdk-v5";

const options = {
  SDKAppID: process.env.VUE_APP_SDKAPPID // 接入时需要将0替换为您的即时通信应用的 SDKAppID
};
// 创建 SDK 实例，TIM.create() 方法对于同一个 SDKAppID 只会返回同一份实例
const tim = TIM.create(options); // SDK 实例通常用 tim 表示
const TIMData = TIM
tim.setLogLevel(0);// 开发环境建议使用，所有提示信息都会提示
// tim.setLogLevel(1);// 生产环境建议使用，只输出关键信息
// 注册 COS SDK 插件
tim.registerPlugin({'cos-js-sdk': COS});



/* eslint-disable require-jsdoc */
function genTestUserSig(userID) {
  const SDKAPPID = process.env.VUE_APP_SDKAPPID;
  const EXPIRETIME = 604800;
  const SECRETKEY = process.env.VUE_APP_SECRETKEY;
  if (SDKAPPID === '' || SECRETKEY === '') {
    alert(
      '请先配置好您的账号信息： SDKAPPID 及 SECRETKEY ' +
        '\r\n\r\nPlease configure your SDKAPPID/SECRETKEY in js/debug/GenerateTestUserSig.js'
    );
  }
  const generator = new LibGenerateTestUserSig(SDKAPPID, SECRETKEY, EXPIRETIME);
  const userSig = generator.genTestUserSig(userID);
  return {
    sdkAppId: SDKAPPID,
    userSig: userSig
  };
}

export default {
	tim,
	TIMData,
	genTestUserSig
}